import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
  Route,
  Navigate,
} from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import ErrorPage from './routes/ErrorPage';
import Main from './routes/Main';
import Screenings from './routes/Screenings';
import Links from './routes/Links';
import ClimateChange from './routes/ClimateChange';
import Scroller from './components/Scroller';
import HandsLikeOurs from './routes/HandsLikeOurs';
import Hillary from './routes/Hillary';
import ProducersDiary from './routes/ProducersDiary';

// IMPORTANT: these routes must sit ABOVE :scrollerId. That route is a
// catch-all, so anything below it gets sent to the Scroller and fails to find
// a match in scrollers.json.
//
// /awards no longer exists as a page. It redirects, because the link may
// already be in circulation.
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />} errorElement={<ErrorPage />}>
      <Route index element={<Main />} />
      <Route path="screenings" element={<Screenings />} />
      <Route path="climate-resilience" element={<ClimateChange />} />
      <Route path="links" element={<Links />} />
      {/* The next film. handslikeours.com and handslikeoursfilm.com point here. */}
      <Route path="handslikeours" element={<HandsLikeOurs />} />
      <Route path="hillary-osullivan" element={<Hillary />} />
      <Route path="handslikeours/producers-diary" element={<ProducersDiary />} />
      <Route path="awards" element={<Navigate to="/screenings" replace />} />
      <Route path="hands-like-ours" element={<Navigate to="/handslikeours" replace />} />
      <Route path="hillary" element={<Navigate to="/hillary-osullivan" replace />} />
      <Route path=":scrollerId" element={<Scroller />} />
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
